import { useZervantSubscriptionDetails } from '@features/zervant-subscription/hooks/useZervantSubscriptionDetails'

import { useOrganizationUiSetup } from '../../../../hooks/useOrganizationUiSetup'

export const useIsSubscriptionEligibleForEInvoicing = () => {
  const {
    isInZervantNoPlan,
    isLoading: isLoadingSubscriptionDetails,
    isPremiumInvoicesQuotaReached,
  } = useZervantSubscriptionDetails()
  const { isUiSetupSupernavInvoicingAccounting } = useOrganizationUiSetup()

  const isSubscriptionEligibleForEInvoicing =
    !isUiSetupSupernavInvoicingAccounting ||
    (!isLoadingSubscriptionDetails && !isInZervantNoPlan && !isPremiumInvoicesQuotaReached)

  return {
    isLoadingSubscriptionDetails,
    isSubscriptionEligibleForEInvoicing,
  }
}
